import { memo, useRef } from 'react';
import FloatAnimation, { FloatAnimationVariant } from './FloatAnimation';
import GlowAnimation from './GlowAnimation';

interface IconProps {
  className?: string;
}

// Cloud path used for both clip-path and visual rendering
const CLOUD_PATH =
  'M51.0684 36.8511C63.2823 36.8511 73.1836 46.7523 73.1836 58.9663C73.1836 59.4119 73.1695 59.8544 73.1436 60.2935H80.3457C89.6283 60.2935 97.1543 67.8184 97.1543 77.1011C97.1541 86.3836 89.6282 93.9087 80.3457 93.9087H30.8076C21.5251 93.9086 14.0002 86.3835 14 77.1011C14 68.4295 20.5669 61.2913 28.999 60.3892C28.9691 59.9187 28.9531 59.4443 28.9531 58.9663C28.9531 46.7523 38.8544 36.8511 51.0684 36.8511Z';

function PartlyCloudyDayIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="122"
      height="120"
      viewBox="0 0 122 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-partly-cloudy-day"
    >
      <g filter="url(#filter0_d_partly_cloudy_day)">
        <circle cx="79" cy="53" r="27" fill="#FFA51F">
          <FloatAnimation variant={FloatAnimationVariant.SunDrift} />
        </circle>
      </g>
      {/* Cloud group - foreignObject and path animate together */}
      <g>
        <FloatAnimation />
        {/* Backdrop blur effect using foreignObject with clip-path */}
        <foreignObject x="-6" y="16.8511" width="123.154" height="97.0576">
          <div
            // @ts-expect-error xmlns is valid for foreignObject content
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              clipPath: 'url(#bgblur_partly_cloudy_day_clip)',
              height: '100%',
              width: '100%',
            }}
          />
        </foreignObject>
        {/* Cloud overlay with semi-transparent fill */}
        <path d={CLOUD_PATH} fill="white" fillOpacity="0.7" />
      </g>
      <defs>
        <filter
          id="filter0_d_partly_cloudy_day"
          x="36"
          y="10"
          width="86"
          height="86"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8">
            <GlowAnimation />
          </feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.852175 0 0 0 0 0.63208 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        {/* Clip path for backdrop blur - offset to match foreignObject position */}
        <clipPath
          id="bgblur_partly_cloudy_day_clip"
          transform="translate(6 -16.8511)"
        >
          <path d={CLOUD_PATH} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(PartlyCloudyDayIcon);
